import cx from 'classnames';
import { ORDER_STATUSES } from 'utils/order/constants';
import { Icon } from '@ontruck/orc';
import { PropTypes } from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StepsBar from 'components/orders/StepsBar';
import { ORDER_STATUSES_MAP } from 'components/orders/DriverStatus/DriverStatus.utils';
import { useFeasibility } from 'hooks/useFeasibility';
import { isStatusBeforeAssigned } from 'utils/order/methods';

const DriverStatus = ({ className, children, order }) => {
  const { t } = useTranslation('ModalSummary');
  const { getIsOrderNonCore } = useFeasibility();

  const { currentStep, currentLabel, isCancelled } = useMemo(() => {
    const showNonCoreConfirmation =
      getIsOrderNonCore(order) && isStatusBeforeAssigned(order.status);

    const status =
      ORDER_STATUSES_MAP[
        showNonCoreConfirmation
          ? ORDER_STATUSES.NON_CORE_PENDING_CONFIRMATION
          : order.status
      ];
    return {
      currentStep: status?.step || 1,
      currentLabel: status?.label,
      isCancelled: order.status === ORDER_STATUSES.CANCELLED,
    };
  }, [order, getIsOrderNonCore]);

  return (
    <li
      className={cx(className, 'status', {
        cancelled: isCancelled,
      })}
      data-testid="driver-status"
    >
      <div className="step-data-wrapper">
        <div className="step-title-wrapper">
          {isCancelled && (
            <span className="step-cancel-icon" data-testid="cancel-icon">
              <Icon glyph="new" size="1.8rem" />
            </span>
          )}
          <span className="driver-state">{t(currentLabel)}</span>
        </div>
        <StepsBar currentStep={currentStep} error={isCancelled} />
        {children}
      </div>
    </li>
  );
};

DriverStatus.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  order: PropTypes.object.isRequired,
};

export default DriverStatus;
